module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 2_Skills_List with bullets.c6239c66.svg";